// EventEmitter.ts

export enum EventConstants {
  REFRESH_TOKEN = "refreshToken",
  SESSION_EXPIRED = "sessionExpired",
  LOGOUT = "logout",
  ADD_ERROR = "addError",
  UNAUTHORIZED = "unauthorized",
}

class GlobalEventEmitter {
  private static instance: GlobalEventEmitter;
  private controller: AbortController = new AbortController();

  private constructor() {}

  public static getInstance(): GlobalEventEmitter {
    if (!GlobalEventEmitter.instance) {
      GlobalEventEmitter.instance = new GlobalEventEmitter();
    }
    return GlobalEventEmitter.instance;
  }

  public emit(eventName: string, detail = {}) {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
  }

  public listen(eventName: string, callback: (event?: CustomEvent) => void) {
    const eventCallback = (event: Event) => callback(event as CustomEvent);
    window.addEventListener(eventName, eventCallback, {
      signal: this.controller.signal,
    });
    return () => window.removeEventListener(eventName, eventCallback);
  }

  public cleanup() {
    this.controller.abort(); // removes all attached listeners
    this.controller = new AbortController(); // reset for future use
  }
}

const globalEventEmitter = GlobalEventEmitter.getInstance();

// ✅ FIX: Use arrow functions to preserve 'this' context
export const emitEvent = (eventName: string, detail = {}) =>
  globalEventEmitter.emit(eventName, detail);
export const listenEvent = (
  eventName: string,
  callback: (event?: CustomEvent) => void,
) => globalEventEmitter.listen(eventName, callback);
export const cleanupEvent = () => globalEventEmitter.cleanup();
